<template>
  <f7-page>
    <f7-navbar
      class="at-navbar secondary-navbar"
      title="Nuevo Marcaje Trabajador"
    >
      <f7-nav-right>
        <f7-link
          icon="icon-close"
          @click="CloseForm()"
        />
      </f7-nav-right>
    </f7-navbar>
    <PCNewWorkerRecord
      :default-selected-worker="selectedWorker"
      template="P1"
      :restrict-day-marking="true"
      :seconds-on-time-picker="true"
      @on-success="ConfirmOperation()"
      @on-cancel="CancelOperation()"
    />
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { usePresenceStore } from '@/js/stores/presence';

import { Log } from '@/js/common/HIDebuggingSupport';
import PCNewWorkerRecord from '@/components/presence/workerRecords/PCNewWorkerRecord.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmNewWorkerRecord',
  components: {
    PCNewWorkerRecord,
  },

  computed: {
    ...mapState(usePresenceStore, ['selectedWorker']),
  },

  mounted() {
    this.StartForm();
  },

  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
    },
    CloseForm() {
      Log(this, this.CloseForm.name);
      f7.views.main.router.back();
    },

    CancelOperation() {
      Log(this, this.CancelOperation.name);
      this.CloseForm();
    },
    ConfirmOperation() {
      Log(this, this.ConfirmOperation.name);
      this.CloseForm();
    },
  },
};
</script>
